export { default } from "./DealsCarousel";
